import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MYOWN_DAILY_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MyOwnDailyReport = lazy(() =>
  import('../../../screens/MyOwnDailyReport')
    .then(module => ({default: module.MyOwnDailyReport})));

const MyOwnDailyReportNavigation = [
  {
    path: ROUTE_MYOWN_DAILY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MyOwnDailyReport />
      </Suspense>
    ),
  },
];

export default MyOwnDailyReportNavigation;
